import { Text } from '@/local/components'

import { Alert, Stack } from '@mui/material'

import { useActions } from '../hooks/useActions'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Body() {
  const texts = useTexts()
  const {
    data: { numberOfImportedOrders, numberOfImportedOrdersWithLowAccuracy },
  } = useController()

  const { selectImportedOrdersWithLowAccuracy } = useActions()

  const showLowAccuracyAlert = numberOfImportedOrdersWithLowAccuracy > 0

  return (
    <Stack direction="column" width="100%" height="100%" flexShrink={0} marginTop={4}>
      <Stack spacing={2} width="100%">
        <Text>{texts.ordersImported(numberOfImportedOrders)}</Text>
        {showLowAccuracyAlert && (
          <Alert
            onClick={selectImportedOrdersWithLowAccuracy}
            severity="warning"
            /*             action={
              <Button color="inherit" size="small">
                {texts.view}
              </Button>
            } */
          >
            {texts.lowAccuracyOrders(numberOfImportedOrdersWithLowAccuracy)}
          </Alert>
        )}
      </Stack>
    </Stack>
  )
}
